import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { AppConfigService } from "@services/config.service";

@Injectable({
  providedIn: "root",
})
export class FilesService {
  private url: string;
  constructor(private http: HttpClient, public config: AppConfigService) {
    this.url = config.get<string>((x) => x.keys_apis.api);
  }

  fileUpload(data: FormData): Observable<any> {
    return this.http.post<any>(this.url + "/v1/File/upload", data);
  }

  getFile(id: string): Observable<any> {
    return this.http.get<any>(this.url + "/v1/File?id=" + id);
  }
}
